import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona si tomo pecho?',
    answer: 'Sí, el método es el complemento ideal para las tomas nocturnas.'
  }, {
    question: '¿Tengo que dejarlo llorar?',
    answer: 'Absolutamente no. Este método se basa en el consuelo y la presencia.'
  }, {
    question: '¿Es un pago único?',
    answer: 'Sí, un solo pago y tienes acceso de por vida a las actualizaciones.'
  }];
  return <section ref={ref} className="w-full bg-cream py-16 md:py-24 px-6" data-id="element-42">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-3xl mx-auto" data-id="element-43">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-12 text-center" data-id="element-44">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 md:px-8 py-6 flex items-center justify-between text-left hover:bg-cream/50 transition-colors duration-200" data-id="element-47">
                <span className="font-serif text-lg md:text-xl font-semibold text-warm-brown pr-4" data-id="element-48">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-soft-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              <motion.div initial={false} animate={{
            height: openIndex === index ? 'auto' : 0,
            opacity: openIndex === index ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-50">
                <div className="px-6 md:px-8 pb-6" data-id="element-51">
                  <p className="text-base md:text-lg text-warm-brown/80 leading-relaxed" data-id="element-52">
                    {faq.answer}
                  </p>
                </div>
              </motion.div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}